import type { Operator } from "./index.js"

// Numeric comparators. Callers pass numbers; the explicit `Number()` wrap keeps
// comparison numeric rather than JS's string-vs-number coercion quirks — `"10" >
// "9"` is false by lex, but `Number("10") > Number("9")` is true. Non-numeric
// strings coerce to NaN and NaN-comparisons are always false, so misuse surfaces
// as "matches nothing" instead of lucky-lex results.

export const greaterThan: Operator = {
  key: "greaterThan",
  label: "greater than",
  icon: "greater-than",
  value: "scalar",
  fn: (a, b) => Number(a) > Number(b),
}

export const greaterThanOrEqual: Operator = {
  key: "greaterThanOrEqual",
  label: "greater than or equal",
  icon: "greater-than-equal",
  value: "scalar",
  fn: (a, b) => Number(a) >= Number(b),
}

export const lessThan: Operator = {
  key: "lessThan",
  label: "less than",
  icon: "less-than",
  value: "scalar",
  fn: (a, b) => Number(a) < Number(b),
}

export const lessThanOrEqual: Operator = {
  key: "lessThanOrEqual",
  label: "less than or equal",
  icon: "less-than-equal",
  value: "scalar",
  fn: (a, b) => Number(a) <= Number(b),
}
